import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { BRAND, AI_FEATURES, SCOPE_TABS } from './constants';
import AiAccessPage from './AiAccessPage';
import AccessSettingsTable from './AccessSettingsTable';

// AI Settings > Ask AI / AI Reporting: everyone, per category, facility and user.
// feature: 'ASSISTANT' (Ask AI) or 'AI_REPORT' (AI-written reports)
function FeatureSettings({ feature }) {
  const [tab, setTab] = useState('GLOBAL');
  const activeTab = SCOPE_TABS.find((t) => t.value === tab);
  const info = AI_FEATURES[feature];

  return (
    <AiAccessPage title={info.title} description={info.description}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
            '& .MuiTab-root': { minHeight: 48, fontWeight: 700, color: 'text.secondary' },
            '& .Mui-selected': { color: `${BRAND} !important` },
          }}
        >
          {SCOPE_TABS.map((t) => (
            <Tab key={t.value} value={t.value} label={t.label} icon={t.icon} iconPosition="start" />
          ))}
        </Tabs>
      </Box>

      <AccessSettingsTable
        key={`${feature}-${tab}`}
        scope={tab}
        noun={activeTab.noun}
        singular={activeTab.singular}
        paged={Boolean(activeTab.paged)}
        feature={feature}
      />
    </AiAccessPage>
  );
}

export default FeatureSettings;
